export const environment = {
  production: false,
  basePath: 'https://bhrcrmsdevapi.rainbow.health/api',
  tenant: 'crms001',
  supportedCountry: ['IN', 'US'],
  idleTimeEnable: true,
  signInVersion: '1.0.0',
  samlLoginUrl: 'https://bhrcrmsdevapi.rainbow.health/api/crms001/saml2/ssologin/web',
  firebase: {
    apiKey: 'AIzaSyBqFvpLk8C5xmp92JkFOW30K08AvaoAEbE',
    authDomain: 'landmark-housecalls-dev.firebaseapp.com',
    projectId: 'landmark-housecalls-dev',
    storageBucket: 'landmark-housecalls-dev.appspot.com',
    messagingSenderId: '684605695872',
    appId: '1:684605695872:web:4146f789f92fe11e7f4365',
    measurementId: 'G-SZH7K91Y70'
  }
};
